import React from 'react'

export default function Support() {
    return (
        <div>
            {window.innerWidth}
        </div>
    )
}
